var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Add a note to selected stops")]),
    _c(
      "div",
      { staticClass: "note-input" },
      [
        _c(
          "md-field",
          [
            _c("label", [_vm._v("Note")]),
            _c("md-textarea", {
              attrs: { "md-autogrow": "" },
              model: {
                value: _vm.noteModel,
                callback: function ($$v) {
                  _vm.noteModel = $$v
                },
                expression: "noteModel",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "note-type-container" }, [
          _c(
            "div",
            { staticClass: "type-field" },
            [
              _c("label", { staticClass: "custom-label" }, [_vm._v("Type")]),
              _c(
                "md-field",
                [
                  _c(
                    "md-select",
                    {
                      attrs: { "md-no-validate": "" },
                      model: {
                        value: _vm.typeModel,
                        callback: function ($$v) {
                          _vm.typeModel = $$v
                        },
                        expression: "typeModel",
                      },
                    },
                    _vm._l(_vm.noteTypes, function (type) {
                      return _c(
                        "md-option",
                        { key: type.name, attrs: { value: type.name } },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(type.name) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }